export default __webpack_public_path__ + "static/media/Ballroll_00268.e0791cff.png";